import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ComunicacionControllerService } from './api/comunicacionController.service';
import { ComunicacionEstadoControllerService } from './api/comunicacionEstadoController.service';
import { ComunicacionHistorialControllerService } from './api/comunicacionHistorialController.service';
import { ComunicacionesCategoriaControllerService } from './api/comunicacionesCategoriaController.service';
import { ComunicacionesSubcategoriaControllerService } from './api/comunicacionesSubcategoriaController.service';
import { ComunicacionesTipoControllerService } from './api/comunicacionesTipoController.service';
import { HelloWorldControllerService } from './api/helloWorldController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ComunicacionControllerService,
    ComunicacionEstadoControllerService,
    ComunicacionHistorialControllerService,
    ComunicacionesCategoriaControllerService,
    ComunicacionesSubcategoriaControllerService,
    ComunicacionesTipoControllerService,
    HelloWorldControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
